import { motion } from "framer-motion";

const VOICES = [
  {
    quote:
      "Dylan didn't sell me a policy — he asked me what I was afraid of. Twenty minutes later, my family was covered for the next thirty years.",
    name: "David L.",
    meta: "Term Life · Portland, OR",
  },
  {
    quote:
      "After my husband passed, our whole life policy paid within days. The mortgage got paid. My kids stayed in their schools. That's what it bought me.",
    name: "Marisela T.",
    meta: "Whole Life · Austin, TX",
  },
  {
    quote:
      "I run three businesses. Nobody had ever explained universal life to me without a slide deck. Dylan did — in a coffee shop, in an hour.",
    name: "Amir R.",
    meta: "Universal Life · Chicago, IL",
  },
];

export default function Voices() {
  return (
    <section id="voices" className="bg-cream border-t border-ink/10" data-testid="voices-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-24 md:py-40">
        <div className="max-w-3xl mb-20">
          <div className="text-ink/40 text-[11px] tracking-[0.3em] mb-8 flex items-center gap-4">
            <span className="w-8 h-[1px] bg-ink/30" />
            CHAPTER 07 · VOICES
          </div>
          <h2 className="font-serif text-ink text-5xl md:text-6xl lg:text-7xl font-light leading-[0.95] tracking-tight">
            What families say <span className="italic text-terracotta">when the paper matters.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {VOICES.map((v, i) => (
            <motion.figure
              key={v.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              className="flex flex-col justify-between border-t-2 border-ink pt-8 min-h-[380px]"
              data-testid={`voice-${i}`}
            >
              <blockquote className="font-serif text-2xl md:text-[26px] text-ink leading-snug font-light italic">
                &ldquo;{v.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-10">
                <div className="font-serif text-lg text-ink">— {v.name}</div>
                <div className="text-[11px] tracking-[0.2em] text-ink/50 mt-2">{v.meta}</div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
